var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-flex ui-flex-row ui-items-center ui-box-border ui-overflow-hidden ui-mx-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }